type ApmFilterPayload = {
  errors?: Array<{
    exception?: {
      message?: string;
    };
  }>;
};

const CEFSHARP_NOISE = /^(?:Unhandled promise rejection: )?Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+$/;

export const filterCefSharpNoise = <TPayload extends ApmFilterPayload>(payload: TPayload): TPayload => {
  if (payload.errors?.length) {
    const retainedErrors = payload.errors.filter(
      (error) => !CEFSHARP_NOISE.test(error.exception?.message ?? ''),
    );

    payload.errors.splice(0, payload.errors.length, ...retainedErrors);
  }

  return payload;
};
